import Button from '@/shared/components/Button'
import OffsetFrame from '@/shared/components/OffsetFrame'

import './ProductsCta.css'

export default function ProductsCta() {
  return (
    <section className="grid items-center gap-8 px-5 py-16 min-[900px]:mx-auto min-[900px]:max-w-[850px] min-[900px]:grid-cols-[1fr_1fr] min-[900px]:gap-14 min-[900px]:py-20">
      <OffsetFrame variant="cta" className="products-cta__frame px-7 py-7">
        <p className="relative">Need the Right Material for Your Project?</p>
      </OffsetFrame>
      <div>
        <p className="products-cta__description max-w-[350px]">Tell us what you are building, renewing, or installing. Tecma will guide you to the right product and quotation.</p>
        <div className="mt-6"><Button size="quote">Contact Experts</Button></div>
      </div>
    </section>
  )
}
